import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { allowedModules, firstAllowedRoute } from "../lib/modules";

export default function ProtectedRoute({ children, module, requireRoles }) {
  const { user, ready } = useAuth();
  const loc = useLocation();

  if (!ready) return <div className="p-10 opacity-60" data-testid="auth-loading">Verifying session…</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;

  // Force a password change before anything else.
  if (user.needs_password_change && loc.pathname !== "/account/password") {
    return <Navigate to="/account/password" replace />;
  }

  // Role-gated routes (e.g. /admin).
  if (requireRoles && !requireRoles.includes(user.role)) {
    return <Navigate to={firstAllowedRoute(user)} replace />;
  }

  // Module entitlement gate.
  if (module && !allowedModules(user).includes(module)) {
    return <Navigate to={firstAllowedRoute(user)} replace />;
  }

  return children;
}
